<template>
    <header class="header">
        <div class="b-container d-flex justify-content-between">
            <h1 class="logo">
                <a href="/">
                    <img :src="$root.siteConfig.logo_path" alt="logo" />
                </a>
            </h1>
            <div class="menu-open js-menu-open">
                <span>Menu</span> <i>&nbsp;</i>
            </div>

            <div class="menu-links">
                <ul class="d-flex">
                    <li
                        v-for="(nav, index) in navs"
                        :key="index"
                        :class="{ 'has-child js-has-child': nav.childs.length }"
                    >
                        <a
                            :href="nav.link"
                            :target="nav.isDownload ? '_blank' : ''"
                        >
                            {{ nav.title }}
                            <i
                                v-if="nav.childs.length"
                                class="icofont-rounded-down"
                            ></i>
                        </a>
                        <ul v-if="nav.childs.length">
                            <li
                                v-for="(child, index) in nav.childs"
                                :key="'c-' + index"
                            >
                                <a
                                    v-if="nav.isCustomChild"
                                    :href="
                                        $root.siteConfig.routes.details.replace(
                                            'name',
                                            child.name
                                        )
                                    "
                                    v-text="child.title"
                                ></a>
                                 <a
                                    v-else
                                    :href="child.link"
                                    v-text="child.title"
                                ></a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="body-overlay"></div>
        </div>
    </header>
</template>
<script>
export default {
    data() {
        return {
            navs: _.filter(this.$root.siteConfig.navs, function(o) {
                return o.inner == false;
            })
        };
    }
};
</script>
